import { NodeSelection } from "@tiptap/pm/state";
import React from "react";
import { createRicosFunctionalExtension } from "./create-ricos-extension";
import styles from "./statics/styles-scss";
const setSelection = (editor, getPos) => {
  const selection = NodeSelection.create(editor.view.state.doc, getPos());
  const transaction = editor.view.state.tr.setSelection(selection);
  editor.view.dispatch(transaction);
};
const OverlayHoc = (Component) => {
  const Overlay = (props) => {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.overlay,
        role: "none",
        onClick: () => {
          setSelection(props.editor, props.getPos);
        }
      },
      /* @__PURE__ */ React.createElement(Component, { ...props })
    );
  };
  Overlay.displayName = "OverlayHoc";
  return Overlay;
};
const overlay = createRicosFunctionalExtension({
  type: "extension",
  name: "overlay",
  groups: [],
  reconfigure: (config, extensions, _props, settings) => ({
    ...config,
    addOptions: () => settings,
    addNodeHoc: () => ({
      nodeTypes: extensions.filter((extension) => extension.groups.includes("overlay")).map(({ name }) => name),
      priority: 10,
      nodeHoc: OverlayHoc
    })
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      priority: 10
    };
  }
});
export {
  OverlayHoc,
  overlay
};
//# sourceMappingURL=overlay.js.map
